<template>
  <div>
    <el-row type="flex" justify="space-between" class="title-bar vertical-center-box">
      <div class="title-h4">수집 설정 키</div>
      <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
    </el-row>
    <el-table-wrapper border :data="tableData" :columns="tableColumn" :column-default="columnDefault" :pagination="false" :show-search-tool="showSearchTool"
      style="width:100%;" header-align="center" :show-custom-header="true">
      <template slot-scope="scope" slot="mapping-value">
        <w-obj-key-setting-value-component :obj-info="objInfo" :basicinfo-set-list="basicinfoSetList" :target-data="scope.row">
        </w-obj-key-setting-value-component>
      </template>
    </el-table-wrapper>
  </div>
</template>

<script>
import { cloneDeep, isEqual, differenceWith, forEach } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { isEmpty } from '@/utils/basic';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';
import WObjKeySettingValueComponent from './ObjKeySettingValueComponent';

export default {
  name: 'WObjKeySettingList',
  components: {
    WObjKeySettingValueComponent,
  },
  props: {
    objInfo: {
      type: Object,
    },
    agentObjId: Number,
    basicinfoSetList: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    basicinfoSetList: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.loadData();
        });
      },
    },
  },
  data() {
    return {
      showSearchTool: false,
      tableData: [],
      columnDefault,
      tableColumn: [
        {
          prop: 'mappingKey',
          label: '설정 키',
          searchable: true,
        },
        {
          prop: 'mappingKeyName',
          label: '설정 키 명',
          searchable: true,
        },
        {
          label: '설정 키 값',
          searchable: true,
          scopedSlot: 'mapping-value',
        },
      ],
      conditionDataList: [],
      tableDataOrigin: [],
      // targetObjKeyData: {},
    };
  },
  methods: {
    loadData() {
      const param = {
        objId: isEmpty(this.agentObjId) ? this.objInfo.obj.objId : this.agentObjId,
      };
      // objId에 해당하는 장비 mappingKey 리스트를 조회한다.
      RuleSettingsAPI.getMappingKeyObjList(param).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
          forEach(this.tableData, (item, index) => {
            if (item.mappingValue && item.datatypeId === 'INTEGER') {
              this.tableData[index].mappingValue = Number(item.mappingValue);
            }
          });
          this.tableDataOrigin = cloneDeep(this.tableData);
        }
      });
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    onSaveButtonClick() {
      const list = differenceWith(this.tableData, this.tableDataOrigin, isEqual);
      const target = '수집 설정 키';
      const action = msgUtil.action.SAVE;
      RuleSettingsAPI.updateMappingKeyObjList(list).then((res) => {
        if (res.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.loadData();
          // this.$alert('저장이 완료되었습니다.', '정보');
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    checkChangeFlag() {
      this.saveFlag = !isEqual(this.tableData, this.tableDataOrigin);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ObjKeySettingList.vue